import { render, staticRenderFns } from "./Aclaraciones.vue?vue&type=template&id=00e8a41e"
import script from "./Aclaraciones.vue?vue&type=script&lang=js"
export * from "./Aclaraciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports